import React from 'react';
import { Table, Button, Modal, notification } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { formatPrice } from '../../../../utils/format';
import { apiDeleteTransactionSplit } from '../../../../api/transactions';

const SplitRule = ({ data, originalAmount, sellerId, transactionId, onSplitDeleted, fees }) => {
  const handleDelete = async (splitId) => {
    try {
      await apiDeleteTransactionSplit(transactionId, splitId);
      notification.success({
        message: 'Sucesso',
        description: 'Split excluído com sucesso!',
      });
      if (onSplitDeleted) {
        onSplitDeleted();
      }
    } catch (error) {
      notification.error({
        message: 'Erro',
        description: 'Erro ao excluir o split',
      });
    }
  };

  const confirmDelete = (record) => {
    Modal.confirm({
      title: 'Tem certeza que deseja deletar este split?',
      content: 'Essa ação não pode ser desfeita.',
      okText: 'Deletar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: () => handleDelete(record?.zoop_id),
    });
  };

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'first_name',
      key: 'first_name',
      render: (text, record) => {
        if (record.seller?.business_name) {
          return record.seller.business_name;
        }
        if (record.seller?.first_name || record.seller?.last_name) {
          return `${record.seller?.first_name ?? ''} ${record.seller?.last_name ?? ''}`.trim();
        }
        return '—';
      },
    },
    {
      title: 'Porcentagem',
      dataIndex: 'percentage',
      key: 'percentage',
      render: (text, record) => {
        if (record.percentage === "0.00") {
          const percentage = ((record.amount / originalAmount) * 100).toFixed(2);
          return <p>{percentage}%</p>;
        }
        return <p>{record.percentage}%</p>;
      },
    },
    {
      title: 'Valor',
      dataIndex: 'amount',
      key: 'amount',
      render: (text, record) => {
        return <p>{formatPrice(record?.amount)}</p>
      },
    },
    {
      title: 'Ações',
      key: 'actions',
      render: (_, record) => {
        if (record.first_name === 'MDR') {
          return null; // Não exibe o botão de deletar para MDR
        }
        return (
          <Button
            type="text"
            size="small"
            icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
            onClick={() => confirmDelete(record)}
            title="Deletar split"
          />
        );
      },
    },
  ];

  const getData = () => {
    let newData = Array.isArray(data) ? [...data] : [];
    if (fees && fees > 0) {
      newData.push({
        first_name: 'MDR',
        percentage: '0.00',
        amount: fees,
        seller: { business_name: 'MDR' },
      });
    }
    return newData;
  }
  
  return (
    <Table
      columns={columns}
      dataSource={getData()}
      pagination={false}
      bordered
      rowKey={(_, index) => index}
      rowClassName={(record) => record.first_name === 'MDR' ? 'mdr-row' : ''}
    />
  );
};

export default SplitRule;
